import { type SanityReviewWidgetModule } from '@data/sanity/queries/types/modules'
import { Reviews } from '@lib/review'

import ReviewCarousel from './review-carousel'
import ReviewList from './review-list'

type ReviewWidgetProps = Pick<
  SanityReviewWidgetModule,
  'type' | 'reviewsStrings'
> & {
  reviews: Reviews
}

const ReviewWidget = ({ type, reviewsStrings, reviews }: ReviewWidgetProps) => {
  switch (type) {
    case 'main': {
      return (
        <ReviewCarousel reviews={reviews} reviewsStrings={reviewsStrings} />
      )
    }

    case 'product': {
      return <ReviewList reviews={reviews} reviewsStrings={reviewsStrings} />
    }
  }
}

export default ReviewWidget
